/* PULL & PUSH — comportamiento del PDP
   Galería, selector de variantes, acordeón y modal de tallas.
   Vanilla JS, sin dependencias. */
(function () {
  'use strict';

  /* ---------------- Galería ---------------- */
  function initGallery(root) {
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-pp-slide]'));
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-pp-thumb]'));
    if (!slides.length) return;

    function show(index) {
      var i = (index + slides.length) % slides.length;
      slides.forEach(function (s, n) {
        if (n === i) { s.setAttribute('data-active', ''); }
        else {
          s.removeAttribute('data-active');
          var v = s.querySelector('video');
          if (v && !v.paused) { v.pause(); }
        }
      });
      thumbs.forEach(function (t, n) { t.setAttribute('aria-current', n === i ? 'true' : 'false'); });
      root.dataset.ppIndex = String(i);
    }

    thumbs.forEach(function (t, n) {
      t.addEventListener('click', function () { show(n); });
    });

    var prev = root.querySelector('[data-pp-prev]');
    var next = root.querySelector('[data-pp-next]');
    if (prev) prev.addEventListener('click', function () { show(parseInt(root.dataset.ppIndex || '0', 10) - 1); });
    if (next) next.addEventListener('click', function () { show(parseInt(root.dataset.ppIndex || '0', 10) + 1); });

    // Salta a la imagen asociada a una variante
    root.addEventListener('pp:media', function (e) {
      var id = e.detail && e.detail.mediaId;
      if (!id) return;
      var target = slides.findIndex(function (s) { return s.dataset.mediaId === String(id); });
      if (target > -1) show(target);
    });

    show(0);
  }

  /* ---------------- Selector de variantes ---------------- */
  function initVariants(root) {
    var dataEl = root.querySelector('[data-pp-variants]');
    if (!dataEl) return;

    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (err) { return; }
    if (!variants || !variants.length) return;

    var idInput = root.querySelector('[data-pp-variant-id]');
    var priceNow = root.querySelector('[data-pp-price-now]');
    var priceWas = root.querySelector('[data-pp-price-was]');
    var submit = root.querySelector('[data-pp-submit]');
    var skuEl = root.querySelector('[data-pp-sku]');
    var gallery = root.querySelector('[data-pp-gallery]');
    var soldOutText = root.dataset.ppSoldout || 'AGOTADO';
    var addText = root.dataset.ppAdd || 'AÑADIR AL CARRITO';
    var pickText = root.dataset.ppPick || 'SELECCIONA UNA TALLA';

    function money(cents) {
      var fmt = root.dataset.ppMoneyFormat || '${{amount}}';
      var value = (cents / 100);
      // Formato colombiano por defecto: sin decimales, punto de miles.
      var noDecimals = /amount_no_decimals/.test(fmt);
      var str = noDecimals
        ? Math.round(value).toLocaleString('es-CO')
        : value.toLocaleString('es-CO', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      return fmt.replace(/\{\{\s*\w+\s*\}\}/, str);
    }

    function selected() {
      return Array.prototype.slice.call(root.querySelectorAll('[data-pp-option]:checked'))
        .map(function (i) { return i.value; });
    }

    function match() {
      var chosen = selected();
      if (chosen.length !== parseInt(root.dataset.ppOptionCount || '1', 10)) return null;
      return variants.find(function (v) {
        return v.options.every(function (o, i) { return o === chosen[i]; });
      }) || null;
    }

    function refreshAvailability() {
      // Desactiva tallas que no existen o están agotadas (solo con 1 opción).
      if (parseInt(root.dataset.ppOptionCount || '1', 10) !== 1) return;
      root.querySelectorAll('[data-pp-option]').forEach(function (input) {
        var v = variants.find(function (x) { return x.options[0] === input.value; });
        input.disabled = !v || (!v.available && root.dataset.ppHideSoldOut === 'true');
      });
    }

    function update() {
      var v = match();

      if (!v) {
        if (submit) { submit.disabled = true; submit.textContent = pickText; }
        return;
      }

      if (idInput) idInput.value = v.id;
      if (priceNow) priceNow.textContent = money(v.price);
      if (priceWas) {
        if (v.compare_at_price && v.compare_at_price > v.price) {
          priceWas.textContent = money(v.compare_at_price);
          priceWas.hidden = false;
        } else { priceWas.hidden = true; }
      }
      if (skuEl) { skuEl.textContent = v.sku || ''; skuEl.hidden = !v.sku; }
      if (submit) {
        submit.disabled = !v.available;
        submit.textContent = v.available ? addText : soldOutText;
      }
      var mediaId = v.featured_media_id || (v.featured_media && v.featured_media.id);
      if (gallery && mediaId) {
        gallery.dispatchEvent(new CustomEvent('pp:media', { detail: { mediaId: mediaId } }));
      }

      if (window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      }
    }

    root.querySelectorAll('[data-pp-option]').forEach(function (input) {
      input.addEventListener('change', update);
    });

    refreshAvailability();
    update();
  }

  /* ---------------- Acordeón ---------------- */
  function initAccordion(root) {
    root.querySelectorAll('[data-pp-acc-btn]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var panel = btn.nextElementSibling;
        var open = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', open ? 'false' : 'true');
        if (panel) {
          if (open) panel.removeAttribute('data-open');
          else panel.setAttribute('data-open', '');
        }
      });
    });
  }

  /* ---------------- Modal ---------------- */
  function initModal(scope) {
    scope.querySelectorAll('[data-pp-modal-open]').forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        var modal = document.getElementById(trigger.getAttribute('data-pp-modal-open'));
        if (!modal) return;
        modal.hidden = false;
        document.body.style.overflow = 'hidden';
        var close = modal.querySelector('[data-pp-modal-close]');
        if (close) close.focus();
      });
    });

    scope.querySelectorAll('[data-pp-modal-close], [data-pp-modal-veil]').forEach(function (el) {
      el.addEventListener('click', function () {
        var modal = el.closest('.pp-modal');
        if (modal) { modal.hidden = true; document.body.style.overflow = ''; }
      });
    });
  }

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    document.querySelectorAll('.pp-modal:not([hidden])').forEach(function (m) {
      m.hidden = true; document.body.style.overflow = '';
    });
  });

  /* ---------------- Arranque ---------------- */
  function boot(scope) {
    (scope || document).querySelectorAll('[data-pp-gallery]').forEach(initGallery);
    (scope || document).querySelectorAll('[data-pp-product]').forEach(function (root) {
      initVariants(root);
      initAccordion(root);
    });
    initModal(scope || document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(document); });
  } else {
    boot(document);
  }

  // Re-inicializa al editar en el personalizador de temas
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
